import { I18n } from '@app/shared/enums/i18n.enum';

const localIP = '192.168.100.183';

export const environment = {
  production: true,
  apiVersion: 1,
  domain: 'wejoiner.com',
  toasterTimeOut: 10000,
  copyTextTimeOut: 2000,
  chatPaginationTimeOut: 3000,
  notFoundTimeOut: 1000,
  beginPageSliderTimeOut: 200,
  baseUrl: {
    base: 'https://apit.wejoiner.com',
    main: 'https://apit.wejoiner.com/wejoiner',
    // main: `http://${localIP}:5101`,
    um: 'https://apit.wejoiner.com/um',
    socket: 'https://apit.wejoiner.com',
    // socket: `http://${localIP}:3201`,
    messenger: 'https://apit.wejoiner.com/messenger',
    // messenger: `http://${localIP}:3201`,
    uploadFile: 'https://apit.wejoiner.com/wejoiner/files',
    file: 'https://apit.wejoiner.com',
    panelUrl: 'https://panelt.wejoiner.com',
    siteVerify: 'https://www.google.com',
  },
  auth: {
    url: 'https://autht.wejoiner.com',
    realm: 'wejoiner',
    clientId: 'website-wejoiner',
    clientUniqueId: '5b44717c-fee3-4d8e-a031-4c8666a605ae',
    apiId: 'api-wejoiner',
  },
  firebase: {
    apiKey: 'AIzaSyCJE97qJYmXkjFj3jEkPZyZGghZeVgH3T4',
    authDomain: 'agbk-dev.firebaseapp.com',
    projectId: 'agbk-dev',
    storageBucket: 'agbk-dev.appspot.com',
    messagingSenderId: '992009507518',
    appId: '1:992009507518:web:cc5caecaa44c85b88084ef',
    vapidKey:
      'BM5ciVDn3-VMwvevNnEBaPa5MvN7Fy10MuiqgofFAi7iypJWOAXp7CqLLg8cQuIrv9ASZLvieB0M46Vx5JTRUFs',
  },
  defaultLang: I18n.en,
  userManagementUrl: 'https://panelt.wejoiner.com/',
  mapApiKey: 'AIzaSyC7A3VZ8sisBhtlspIINS8AHkDNZ3npvyg',
  recaptcha: {
    siteKey: '6LdpKW4qAAAAALnc2ph1Bb15dyPW5IR86XW-yLTp',
    targetScore: 0.7,
  },
  googleAnalytics: 'G-LRRF09WVQG',
  gtmId: 'GTM-5F8SDFK9',
  matomoEnabled: false,
  matomoSiteId: 3,
  matomoTrackerUrl: 'https://wejoiner.matomo.cloud',
  /** Matomo Cloud serves tracker JS from CDN, not from trackerUrl */
  matomoScriptUrl: 'https://cdn.matomo.cloud/wejoiner.matomo.cloud/matomo.js',
};
